import script from "./healthQuestionnaire.vue?vue&type=script&setup=true&lang=ts"
export * from "./healthQuestionnaire.vue?vue&type=script&setup=true&lang=ts"

import "./healthQuestionnaire.vue?vue&type=style&index=0&id=eee86218&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eee86218"]])

export default __exports__